import React from 'react';
import { useHistory } from '../../providers/HistoryProvider';
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/solid';
import { useVetRec } from '../../providers/VetRecProvider';

interface DavidButtonProps {
    className?: string;
}

export const DavidButton: React.FC<DavidButtonProps> = ({ className = "" }) => {
    const { setShowChatBot } = useHistory();
    const { davidEnabled } = useVetRec();
  
    if (!davidEnabled) return null;
  
    return (
      <button
        data-tour-id="chat-button"
        type="button"
        className={`
          inline-flex items-center justify-center
          gap-x-1            /* tighter icon/text spacing */
          rounded-md
          bg-main-button
          px-2               /* same horizontal padding */
          py-1.5             /* less vertical padding */
          font-semibold
          text-main-button-text
          shadow-sm
          hover:bg-main-button-hover
          focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600
          text-xs sm:text-sm /* smaller text on mobile, normal on desktop */
          w-auto
          ${className}
        `}
        onClick={() => setShowChatBot(true)}
      >
        <ChatBubbleBottomCenterTextIcon
          className="h-5 w-5 text-main-button-text"
          aria-hidden="true"
        />
        <span className="hidden sm:block">D.A.V.I.D</span>
      </button>
    );
  };